import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BackwardFilledSvg from "@ant-design/icons-svg/es/asn/BackwardFilled";
import AntdIcon from "../components/AntdIcon";
var BackwardFilled = function BackwardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BackwardFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BackwardFilled.displayName = 'BackwardFilled';
}
export default /*#__PURE__*/React.forwardRef(BackwardFilled);